
export const type= 'GET-RECIPES-WHIT-MAYONESA'
const GetRecipesWhitMayonesa = ()=>({
    type
})
export default GetRecipesWhitMayonesa